<div class="btn-group" ngbDropdown role="group">
    <button type="button" class="btn btn-outline-primary bouton-indicatif-telephonique" ngbDropdownToggle>
        <span *ngIf="indexIndicatif !== undefined"
              class="flag-icon flag-icon-{{listeIndicatif[indexIndicatif].refPictoPays}}">
        </span>
        <span *ngIf="indexIndicatif !== undefined" class="ms-1">
            {{listeIndicatif[indexIndicatif].libellePays}}
        </span>
    </button>
    <div class="dropdown-menu c-dropdown-menu w-auto" ngbDropdownMenu>
        <button role="option" type="button" class="dropdown-item d-flex justify-content-between"
                *ngFor="let indicatif of listeIndicatif; index as i; trackBy:trackById"
                (click)="onClickIndicatif(indicatif, i)"
                [attr.aria-label]="indicatif.libellePays">
            <div class="me-2">
                <aside class="flag-icon flag-icon-{{indicatif.refPictoPays}} cursor-pointer"></aside>
                {{indicatif.libellePays}}
            </div>
            {{indicatif.indicatifTelephonique}}
        </button>
    </div>
</div>
